import {
  Artist,
  Instrument,
  MixedModelConstructedNoDates,
  ModelNoDates,
} from "@/types/types";
import { getArtistInstrumentModel } from "@/utils/artistInstrumentModelMixedModel/get/getArtistInstrumentModel";
import { getMixedModel } from "@/utils/artistInstrumentModelMixedModel/get/getMixedModel";

export const getArtistInstrumentModelMixedModel = (
  id: string,
  models: ModelNoDates[] | null,
  mixedModels: MixedModelConstructedNoDates[] | null
): Artist | Instrument | ModelNoDates | MixedModelConstructedNoDates | null => {
  const foundArtistInstrumentModel = getArtistInstrumentModel(id, models);
  if (foundArtistInstrumentModel !== null) {
    return foundArtistInstrumentModel;
  }

  // Check if the id is a mixed model
  if (mixedModels !== null) {
    const foundMixedModel = getMixedModel(id, mixedModels);

    if (foundMixedModel !== null) {
      return foundMixedModel;
    }
  }

  // If the id is not found return null
  return null;
};
